import { callAxleService } from "./axle";
import { SERVICE_CENTER_BASE_URL } from "./constants";

// dmv is the ALB's root catch-all — no service path segment.
const dmvBaseUrl = SERVICE_CENTER_BASE_URL;

type IgnitionUser = {
  id: string;
  email?: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
};

export const startIgnition = async (
  clientId: string,
  clientSecret: string,
  user: IgnitionUser,
  redirectUri?: string,
  webhookUri?: string
) => {
  return await callAxleService(
    `${dmvBaseUrl}/ignition`,
    {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        "x-client-id": clientId, // Ignition Super Test
        "x-client-secret": clientSecret, // Client secret for this client
      },
      data: {
        user,
        redirectUri,
        webhookUri,
      },
    },
    "axios"
  );
};

export const exchangeToken = async (
  authCode: string,
  clientId: string,
  clientSecret: string
) => {
  return await callAxleService(
    `${dmvBaseUrl}/token/exchange`,
    {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "x-client-id": clientId, // Ignition Super Test
        "x-client-secret": clientSecret,
      },
      data: {
        authCode,
      },
    },
    "axios"
  );
};

export const getAccount = async (
  clientId: string,
  accessToken: string,
  account: string
) => {
  return await callAxleService(`${dmvBaseUrl}/accounts/${account}`, {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      "x-client-id": clientId,
      "x-access-token": accessToken,
    },
  });
};

/**
 * It makes a GET request to the DMV API to get a client's information
 * @param clientId - The id of the client you want to get.
 * @returns The client object
 */
export const getClient = async (clientId: string) => {
  return await callAxleService(`${dmvBaseUrl}/clients/${clientId}`, {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

/**
 * It makes a GET request to the Ignition API to get the configuration of a client
 * @param clientId - The client ID of the client you want to get the ignition config for.
 * @returns the data from the response body.
 */
export const getClientWithIgnitionConfig = async (
  clientId: string,
  templateId?: string
) => {
  const url = new URL(`${dmvBaseUrl}/clients/${clientId}/ignition-config`);
  if (templateId) url.searchParams.set("templateId", templateId);
  return await callAxleService(url.toString(), {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
  });
};
